import './src/styles/global.css';
import { analytics } from './src/analytics';

export const onClientEntry = () =>
{
  analytics.init()
}
